import { render, staticRenderFns } from "./ExamTypeForm.vue?vue&type=template&id=512f0353&scoped=true"
import script from "./ExamTypeForm.vue?vue&type=script&lang=js"
export * from "./ExamTypeForm.vue?vue&type=script&lang=js"
import style0 from "./ExamTypeForm.vue?vue&type=style&index=0&id=512f0353&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512f0353",
  null
  
)

export default component.exports